import type { ReactNode } from "react";
import { cx } from "shared/utils";
import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";
import {
  type BannerButtonGroupPosition,
  type BannerVariant,
  type ButtonProps,
  BOTTOM_BUTTON_COLOR_CLASSES,
  isButtonObject
} from "../utils";

type BannerButtonProps = {
  button: ButtonProps | undefined;
  variant: BannerVariant;
  buttonGroupPosition?: BannerButtonGroupPosition;
  greyTextWhenBottom: boolean;
};

/* eslint-disable sonarjs/function-return-type -- null | JSX | ReactNode all valid ReactNode; Sonar flags multiple return expressions */
export const BannerButton = ({
  button,
  variant,
  buttonGroupPosition = "right",
  greyTextWhenBottom
}: BannerButtonProps) => {
  const isRightPosition = buttonGroupPosition === "right";
  if (!button) return null;

  if (isButtonObject(button)) {
    if (isRightPosition)
      return (
        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.SM}
          onClick={button.onClick}
        >
          {button.text}
        </Button>
      );

    const override = BOTTOM_BUTTON_COLOR_CLASSES[variant];
    let colorClasses = "";

    if (greyTextWhenBottom)
      colorClasses = "!text-content-500 hover:!text-content-600";
    else if (override) colorClasses = cx(override.text, override.hover);

    return (
      <Button
        variant={ButtonVariant.TEXT}
        onClick={button.onClick}
        className={cx(colorClasses, "text-sm")}
      >
        {button.text}
      </Button>
    );
  }

  return button as ReactNode;
};
